// extracted by mini-css-extract-plugin
export var dataCell = "_qj-2";
export var dataRow = "_qj-0";
export var headerRow = "_qj-1";